import React, { Suspense, lazy } from 'react';
import type { PinPickerMapProps } from './PinPickerMap';

// Leaflet downloads only when the pin map is shown (plan 13).
const PinPickerMap = lazy(() => import('./PinPickerMap'));

export default function LazyPinPickerMap(props: PinPickerMapProps) {
  return (
    // `isolate`: Leaflet's layers (z-index 400–1000) stay inside the map, under the
    // sticky Save bar and the top menu.
    <div className="isolate">
      <Suspense
        fallback={<div className={`${props.className ?? 'h-72 w-full rounded-[16px]'} bg-fog animate-pulse`} />}
      >
        <PinPickerMap {...props} />
      </Suspense>
    </div>
  );
}
